import React from "react";
import * as S from "./styles";
import { useLocation, useNavigate } from "react-router-dom";

const NavBar: React.FC = () => {
  const param = useLocation().pathname;
  const navigate = useNavigate();

  return (
    <S.Container>
      <S.NavContainerIsAdmin>
        <S.ButtonNavIsAdmin
          onClick={() => navigate("/news")}
          boolean={param === "/news" ? true : false}
        >
          <S.NewsIcon boolean={param === "/news" ? true : false}></S.NewsIcon>
        </S.ButtonNavIsAdmin>
        <S.ButtonNavIsAdmin
          onClick={() => navigate("/wallet")}
          boolean={param === "/wallet" ? true : false}
        >
          <S.WalletIcon
            boolean={param === "/wallet" ? true : false}
          ></S.WalletIcon>
        </S.ButtonNavIsAdmin>
        <S.ButtonNavIsAdmin
          onClick={() => navigate("/contacts")}
          boolean={param === "/contacts" ? true : false}
        >
          <S.ContactIcon
            boolean={param === "/contacts" ? true : false}
          ></S.ContactIcon>
        </S.ButtonNavIsAdmin>
        <S.ButtonNavIsAdmin
          onClick={() => navigate("/config")}
          boolean={param === "/config" ? true : false}
        >
          <S.EditAccount
            boolean={param === "/config" ? true : false}
          ></S.EditAccount>
        </S.ButtonNavIsAdmin>
      </S.NavContainerIsAdmin>
    </S.Container>
  );
};

export default NavBar;
